import { createSlice } from "@reduxjs/toolkit";
import { getAllDepots, addNewDepot, addNewDepotPersonal, getAllDepotPerson, getByIdDepot, getByIdDepotPersonal, setCurrentSelectedTab, editDepot, unlistDepot, DeactiveAccount } from "src/thunks/depotUsers";

const initState = {
    loading: false,
    depoData: [],
    depoPersonel: [],
    individualDepotInfo: [],
    individualDepotPersonnelInfo: [],
    selectedTab: "DEPOTS",
    getAllDepotsLoading: false,
    addNewDepotLoading: false,
    addNewDepotPersonelLoading: false
};

const DepotUsers = createSlice({
    name: "depotUsers",
    initialState: initState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder

                /** De-activate depot personnel account ------------------------------------**/
                .addCase(DeactiveAccount.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(DeactiveAccount.fulfilled, (state, action) => {
                    state.loading = false;
                    state.depoData = action.payload;
                })
                .addCase(DeactiveAccount.rejected, (state, action) => {
                })

                /** Unlist depot ----------------------------------- **/
                .addCase(unlistDepot.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(unlistDepot.fulfilled, (state, action) => {
                    state.loading = false;
                    state.depoData = action.payload;
                })
                .addCase(unlistDepot.rejected, (state, action) => {
                })

                /** Get all depots data ---------------------------------- **/
                .addCase(getAllDepots.pending, (state, action) => {
                    state.getAllDepotsLoading = true;
                })
                .addCase(getAllDepots.fulfilled, (state, action) => {
                    state.getAllDepotsLoading = false;
                    state.depoData = action.payload;
                })
                .addCase(getAllDepots.rejected, (state, action) => {
                    state.getAllDepotsLoading = false;
                })

                /** Add new depot ----------------------------- **/
                .addCase(addNewDepot.pending, (state, action) => {
                    state.addNewDepotLoading = true;
                })
                .addCase(addNewDepot.fulfilled, (state, action) => {
                    state.addNewDepotLoading = false;
                    state.depoData = action.payload;
                })
                .addCase(addNewDepot.rejected, (state, action) => {
                    state.addNewDepotLoading = false
                })
                
                /** Edit existing depot ------------------------ **/
                .addCase(editDepot.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(editDepot.fulfilled, (state, action) => {
                    state.loading = false;
                    state.depoData = action.payload;
                })
                .addCase(editDepot.rejected, (state, action) => {
                    state.loading = false
                })

                /** Get all depot personnel or get all project manager data --------------------- **/
                .addCase(getAllDepotPerson.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getAllDepotPerson.fulfilled, (state, action) => {
                    state.loading = false;
                    state.depoPersonel = action.payload;
                })
                .addCase(getAllDepotPerson.rejected, (state, action) => {
                })


                /** Get by depot id --------------------------------- **/
                .addCase(getByIdDepot.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getByIdDepot.fulfilled, (state, action) => {
                    state.loading = false;
                    state.individualDepotInfo = action.payload;
                })
                .addCase(getByIdDepot.rejected, (state, action) => {
                    state.loading = false;
                })

                /** Add new depot personnel or add new project manager ---------------**/
                .addCase(addNewDepotPersonal.pending, (state, action) => {
                    state.addNewDepotPersonelLoading = true;
                })
                .addCase(addNewDepotPersonal.fulfilled, (state, action) => {
                    state.addNewDepotPersonelLoading = false;
                    // state.depoPersonel = action.payload;
                })
                .addCase(addNewDepotPersonal.rejected, (state, action) => {
                    state.addNewDepotPersonelLoading = false
                })

                /** Get by id depot perosnal data or get by id project manager data ----------------**/
                .addCase(getByIdDepotPersonal.pending, (state, action) => {
                    state.loading = true;
                })
                .addCase(getByIdDepotPersonal.fulfilled, (state, action) => {
                    state.loading = false;
                    state.individualDepotPersonnelInfo = action.payload;
                })
                .addCase(getByIdDepotPersonal.rejected, (state, action) => {
                    state.loading = false;
                })

                /** To get currently selected admin tab name ----------------------- **/
                .addCase(setCurrentSelectedTab, (state, action) => {
                    state.loading = false;
                    state.selectedTab = action.payload;
                })
        },
});

export default DepotUsers;